import React from "react";
import PropTypes from "prop-types";
import BlockIcon from "@mui/icons-material/Block";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { BoldCell } from "components/common/TableStyles";

export const ScoringAttributeListComponent = ({ attributeList }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <BoldCell>{"Name"}</BoldCell>
          <BoldCell align="right">{"Value"}</BoldCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {attributeList.map(x => {
          return (
            <TableRow key={x.engineAttributeId}>
              <TableCell>{x.name}</TableCell>
              {x.sensitiveInfo ? (
                <TableCell align="left" pb="1">
                  <Grid container spacing={1} justifyContent="flex-end">
                    <Grid item align="left"></Grid>
                    <BlockIcon />
                    <Grid item pt="2">
                      {"SensitiveInfo"}
                    </Grid>
                  </Grid>
                </TableCell>
              ) : (
                <TableCell align="right">{x.value}</TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

ScoringAttributeListComponent.propTypes = {
  attributeList: PropTypes.array.isRequired
};

export default ScoringAttributeListComponent;
